import { AllowedChain } from '@/types';
import { Hex } from 'viem';
import { sepolia, gnosis } from 'viem/chains';

const PIMLICO_API_KEY = process.env.NEXT_PUBLIC_PIMLICO_API_KEY as string;
export const NETWORK_NAME = process.env
  .NEXT_PUBLIC_NETWORK_NAME as AllowedChain;
export const IS_ENS_LINKED = 'IS_ENS_LINKED';

const RPC_URL_MAP: Record<AllowedChain, string[]> = {
  [AllowedChain.Sepolia]: [
    'https://rpc.ankr.com/eth_sepolia',
    'https://eth-sepolia.g.alchemy.com/v2/iu7jObrJF2MAYHNrVwuh7cah4xg9g8iN',
  ],
  [AllowedChain.Gnosis]: [
    'https://rpc.ankr.com/gnosis/9ed50989d819f8036e2e8b77772fb50f074ef3d1fc6c3c289dbe3e192e25101d',
    'https://gnosis-mainnet.g.alchemy.com/v2/j8AfuDiUo1n8u36QxaQQht3BBRBHXOzj',
  ],
};

const VIEM_CHAIN_MAP = {
  [AllowedChain.Sepolia]: sepolia,
  [AllowedChain.Gnosis]: gnosis,
};
const VIEM_CHAIN_ID_MAP = {
  [AllowedChain.Sepolia]: sepolia.id,
  [AllowedChain.Gnosis]: gnosis.id,
};

const REGISTRY_CONTRACT_ADDRESS_MAP: Record<AllowedChain, Hex> = {
  [AllowedChain.Sepolia]: '0x92e0bb8CFD97da712F366A350ff2B7A7873A62A2',
  [AllowedChain.Gnosis]: '0xCad72Ff216A5192bc2DB7412aca6C400d23Fc444',
};

const COMMENT_CONTRACT_ADDRESS_MAP: Record<AllowedChain, Hex> = {
  [AllowedChain.Sepolia]: '0x404c5e60fC3E2AFBe209Fb5E0fB6fFf7Ff3c1c6E',
  [AllowedChain.Gnosis]: '0xb9A98BcC2C3c48D78BD75809971F5c0BD3bEA294',
};

export const WS_RPC_ENDPOINT_MAP: Record<AllowedChain, string> = {
  [AllowedChain.Sepolia]: 'wss://ethereum-sepolia-rpc.publicnode.com',
  [AllowedChain.Gnosis]: 'wss://gnosis-rpc.publicnode.com',
};

export const constants = {};

export const PRIVY_APP_ID = process.env.NEXT_PUBLIC_PRIVY_APP_ID as string;

export const RPC_URL = RPC_URL_MAP[NETWORK_NAME];
export const CHAIN = VIEM_CHAIN_MAP[NETWORK_NAME];
export const WS_RPC_ENDPOINT = WS_RPC_ENDPOINT_MAP[NETWORK_NAME];
export const CHAIN_ID = VIEM_CHAIN_ID_MAP[NETWORK_NAME];

export const PAYMASTER_URL = `https://api.pimlico.io/v2/${NETWORK_NAME}/rpc?apikey=${PIMLICO_API_KEY}`;
export const BUNDLER_URL = `https://api.pimlico.io/v2/${NETWORK_NAME}/rpc?apikey=${PIMLICO_API_KEY}`;
export const GUN_PEER_URL = process.env.NEXT_PUBLIC_GUN_PEER_URL as string;
export const UPLOAD_API_URL =
  (process.env.NEXT_PUBLIC_STORAGE_BACKEND as string) + '/upload/';

export const STORAGE_DID = process.env.NEXT_PUBLIC_STORAGE_DID as string;

export const REGISTRY_CONTRACT_ADDRESS =
  REGISTRY_CONTRACT_ADDRESS_MAP[NETWORK_NAME];

export const COMMENT_CONTRACT_ADDRESS =
  COMMENT_CONTRACT_ADDRESS_MAP[NETWORK_NAME];

export const PORTAL_METADATA_IPFS_HASH =
  'bafybeiaykerbqrx2x6ofcvholtkkknueazwedakyb5tri2e2uu7von2yke';

export const SIGN_IN_MESSAGE = 'Sign in to Fileverse';
export const COMMENT_SIGN_IN_MESSAGE =
  'Create a "Comment" account to leave comments on dDocs.';
export const RANDOM_USER_NAME_FOR_COMMENT = 'RANDOM_USER_NAME_FOR_COMMENT';

export const DB_VERSION = process.env.NEXT_PUBLIC_DB_VERSION;

export const GUN_ENV_NAMESPACE_KEY =
  process.env.NEXT_PUBLIC_GUN_ENV_NAMESPACE_KEY + '/' + DB_VERSION;

export const IDB_NAME = 'DdocDatabase_' + DB_VERSION;

export const HKDF_KEY_INFO = 'encryptionKey';

export const FILE_SOURCE_MAP = {
  DDOC: 'fileverse_document',
};

export const IPFS_GATEWAY_URL =
  (process.env.NEXT_PUBLIC_IPFS_GATEWAY_URLS?.split(', ')[0] as string) +
  '/ipfs/';
export const DEFAULT_AUTHENTICATED_HEADER = {
  'x-api-key': process.env.NEXT_PUBLIC_STORAGE_API_KEY,
};

export const ACTIVE_COLLABORATION_FLAG = 'active_collaboration';

export const LATEST_DOC_ID = 'latestDocId';
export const CREATED_DOC_ID = 'createdDocId';
export const TEMP_DOC_ID = 'tempDocId';
export const CORRUPT_CONTENT = {
  type: 'dBlock',
  content: [
    {
      type: 'paragraph',
      attrs: {
        textAlign: 'left',
      },
    },
  ],
};

export const LS_ENS_MAP = 'ENS_MAP_v2';

export enum RequestKey {
  GET_DDOCS = 'GET_DDOCS',
}

export const ARCH_VERSION = 'v3';
export const LATEST_DDOC_VERSION = '3';
export const VERSION_AFTER_YJS_UPDATE = '2';
